import { autobind } from 'core-decorators';
import { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { trackEvent } from '/@/store/tracking/actions';
import { getBrowser, getOS, isMobile, isStandAlone, isTablet } from '/@/utils';
import BrowserRequest from './browser-request';
import Steps from './steps';
import styles from './styles.module.css';

@connect(null, (dispatch) => ({
    ...bindActionCreators({ trackEvent }, dispatch),
}))
@autobind
export default class InstallationTutorial extends Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: this.shouldShowTutorial(),
        };
    }

    shouldShowTutorial() {
        let displayCount = Number.parseInt(window.localStorage.getItem('cultivio.tutorial')) || 0;
        if (isMobile() && !isStandAlone() && displayCount > 2) {
            this.props.trackEvent({ key: 'tutorial.show' });
            window.localStorage.setItem('cultivio.tutorial', ++displayCount);
            return true;
        }
    }

    handleClose() {
        this.setState({ visible: false });
    }

    renderStep() {
        if (!this.shouldShowTutorial()) return null;

        if (getOS() === 'iOS') {
            if (!getBrowser().includes('Safari')) return <BrowserRequest browser='Safari' />;
            return <Steps os='iOS' isTablet={isTablet()} onClose={this.handleClose} />;
        }

        if (!getBrowser().includes('Chrome')) return <BrowserRequest browser='Google Chrome' />;
        return <Steps os='Android' onClose={this.handleClose} />;
    }

    render() {
        return !this.state.visible ? null : <div className={styles.root}>{this.renderStep()}</div>;
    }
}
